import React, { useEffect } from 'react'
import classes from './Portfolio.module.css'
import {
  animated,
  useSpring,
  useChain,
  config,
  useSpringRef,
} from 'react-spring'
import Card from './Card'
import covidImg from '../../assets/covidind.jpg'
import irfaImg from '../../assets/irfaa.png'
import zakatImg from '../../assets/zakat.png'

const works = [
  {
    title: 'Covid updates dashboard',
    description:
      'A covid dashboard made by the students of sscollege areekode during lockdown time',
    imgUrl: covidImg,
  },
  {
    title: 'Irfa Foundation website',
    description: 'Website for a canadian organisation irfaa.ca',
    imgUrl: irfaImg,
  },
  {
    title: 'ZakatCell WebApp',
    description:
      'A web app for islamic society zakat survey and data collection',
    imgUrl: zakatImg,
  },
]

const Portfolio = () => {
  //springs and refs
  const l1ref = useSpringRef()
  const l2ref = useSpringRef()
  const l3ref = useSpringRef()
  const card1Ref = useSpringRef()
  const card2Ref = useSpringRef()
  const card3Ref = useSpringRef()

  const cardRefs = [card1Ref, card2Ref, card3Ref]

  const l1Spring = useSpring({
    from: { transform: 'translateY(50px)', opacity: 0 },
    to: { transform: 'translateY(0px)', opacity: 1 },
    ref: l1ref,
  })
  const l2Spring = useSpring({
    from: { transform: 'translateX(-50px)', opacity: 0 },
    to: { transform: 'translateX(0px)', opacity: 1 },
    ref: l2ref,
  })
  const card1Spring = useSpring({
    from: { transform: 'translateY(200px)', opacity: 0 },
    to: { transform: 'translateY(0px)', opacity: 1 },
    ref: card1Ref,
  })
  const card2Spring = useSpring({
    from: { transform: 'translateY(200px)', opacity: 0 },
    to: { transform: 'translateY(0px)', opacity: 1 },
    ref: card2Ref,
  })
  const card3Spring = useSpring({
    from: { transform: 'translateY(200px)', opacity: 0 },
    to: { transform: 'translateY(0px)', opacity: 1 },
    ref: card3Ref,
  })

  const cardSprings = [card1Spring, card2Spring, card3Spring]

  useChain([l1ref, l2ref, l3ref, ...cardRefs], [0, 0.1, 0.2, 0.3, 0.4, 0.5])

  return (
    <div className={classes.container}>
      <animated.h1 className={classes.header} style={l1Spring}>
        See my{' '}
        <animated.span className={classes.green} style={l2Spring}>
          works
        </animated.span>
      </animated.h1>
      <animated.div className={classes.cardContainer}>
        {works.map((work, index) => (
          <Card {...work} style={cardSprings[index]} />
        ))}
      </animated.div>
    </div>
  )
}

export default Portfolio
